import { useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import { useTranslation } from "react-i18next";
import useNotify from "hooks/useNotify";
import profileApi from "api/profile";
import { actions } from "store/actions";

function useExperience() {
  const dispatch = useDispatch();
  const [t] = useTranslation();
  const userDetails = useSelector((state) => state.userDetails || {});
  const [isLoading, setIsLoading] = useState(false);
  const [isEditExperience, setIsEditExperience] = useState(false);
  const { notifyError, notifySuccess } = useNotify();

  const agencyId = userDetails?.agencyId;
  const userId = userDetails?.id;

  const onSaveExperience = async (values) => {
    try {
      setIsLoading(true);
      const { domains, subDomains, customDomain, catTools, hasCatToolsExperience } = values;

      await profileApi.updateAgencyExperienceApi(agencyId, {
        domains,
        subDomains,
        customDomain,
        hasCatToolsExperience: hasCatToolsExperience ?? false,
        catTools: hasCatToolsExperience ? (catTools ?? []) : [],
      });

      notifySuccess(t("successfullyUpdated"));

      dispatch(actions.fetchUserDetails(userId));
      dispatch(actions.fetchUserDomains(userId));
      dispatch(actions.fetchUserSubDomains(userId));

      setIsEditExperience(false);
    } catch (error) {
      notifyError(error?.message || t("errorOccurred"));
    } finally {
      setIsLoading(false);
    }
  };

  return {
    isLoading,
    isEditExperience,
    setIsEditExperience,
    onSaveExperience,
  };
}

export default useExperience;
